import React, { useEffect, useState } from "react";
import { RoutesLink } from "../../ApiHelper/RoutesLink";
import { Link, NavLink, useLocation, useNavigate } from "react-router-dom";
import Cookies from "js-cookie";
import {
  saveActiveSidebarTab,
  saveSideBarScrollPosition,
  updateDateFilter,
  updateFiltersStates,
} from "../../store/actions/UserActions";
import DashboardIcon from "../Icons/Sidebar/DashboardIcon";
import SitesIcon from "../Icons/Sidebar/SitesIcon";
import AttendanceIcon from "../Icons/Sidebar/AttendanceIcon";
import LeaveIcon from "../Icons/Sidebar/LeaveIcon";
import AttRegulerizationIcon from "../Icons/Sidebar/AttRegulerizationIcon";
import ODAplicationIcon from "../Icons/Sidebar/ODAplicationIcon";
import PaySlipIcon from "../Icons/Sidebar/PaySlipIcon";
import ItemMasterIcon from "../Icons/Sidebar/ItemMasterIcon";
import CompanyIcon from "../Icons/Sidebar/CompanyIcon";
import LedgerIcon from "../Icons/Sidebar/LedgerIcon";
import { useSelector } from "react-redux";
import { useDispatch } from "react-redux";
import NotificationIcon from "../Icons/Sidebar/NotificationIcon";
import VoucherIcon from "../Icons/Sidebar/VoucherIcon";
import StockInOut from "../Icons/Sidebar/StockInOut";
import BudgetIcon from "../Icons/Sidebar/BudgetIcon";
import { OfficeTaskIcon } from "../Icons/Sidebar/OfficeTaskIcon";
import { SiteTaskIcon } from "../Icons/Sidebar/SiteTaskIcon";
import { HowToUseIcon } from "../Icons/Sidebar/HowToUseIcon";
import moment from "moment";
import { getCurrentFinancialYear } from "../../utility/CommonFunctions";
import ChevronArrow from "../Icons/Sidebar/ChevronArrow";

function AdminSidebar() {
  const dispatch = useDispatch();
  const location = useLocation();
  const nonActiveNumber = -1;

  const activeSidebarTab = useSelector(
    (state) => state?.root?.activeSidebarTab
  );

  const scrollPosition = useSelector((state) => state?.root?.scrollPosition);

  const groupedMenu = {
    Site: [
      {
        label: "Company",
        to: RoutesLink.company,
        relatedRoutes: [
          RoutesLink.company,
          RoutesLink?.add_company,
          `${RoutesLink?.company_detail}/:id`,
        ],
        icon: <CompanyIcon />,
      },
      {
        label: "Customers",
        to: RoutesLink.customers,
        relatedRoutes: [
          RoutesLink.customers,
          RoutesLink?.add_customer,
          `${RoutesLink?.customer_detail}/:id`,
        ],
        icon: <ItemMasterIcon />,
      },
      {
        label: "O&M",
        to: RoutesLink.sites_OandM,
        relatedRoutes: [RoutesLink.sites_OandM],
        icon: "",
        subMenu: [
          {
            label: "Sites",
            to: RoutesLink.sites_OandM,
            relatedRoutes: [
              RoutesLink.sites_OandM,
              RoutesLink?.add_site,
              `${RoutesLink?.site_detail}/:id`,
            ],
          },
          {
            label: "Site Salary Head",
            to: RoutesLink.site_salary_head,
            state: { data: { type: "O%26M" } },
            relatedRoutes: [
              RoutesLink.site_salary_head,
              RoutesLink?.add_salary_head,
            ],
          },
        ],
      },
      {
        label: "Project",
        to: RoutesLink.sites_project,
        relatedRoutes: [RoutesLink.sites_project],
        icon: "",
        subMenu: [
          {
            label: "Sites",
            to: RoutesLink.sites_project,
            relatedRoutes: [
              RoutesLink.sites_project,
              RoutesLink?.add_site,
              `${RoutesLink?.site_detail}/:id`,
            ],
          },
          {
            label: "Site Salary Head",
            permissionKey: "show",
            to: RoutesLink.site_salary_head,
            state: { data: { type: "project" } },
            relatedRoutes: [
              RoutesLink.site_salary_head,
              RoutesLink?.add_salary_head,
            ],
          },
        ],
      },
      {
        label: "Budget Request",
        to: RoutesLink.budget_requests,
        relatedRoutes: [
          RoutesLink.budget_requests,
          `${RoutesLink?.budget_logs}/:id`,
        ],
        icon: <BudgetIcon />,
      },
    ],
    HRM: [
      {
        label: "Attendance",
        to: RoutesLink.attendance_admin,
        relatedRoutes: [RoutesLink.attendance_admin],
        icon: <AttendanceIcon />,
      },
      {
        label: "Att. Summary",
        to: RoutesLink.attendance_summary,
        relatedRoutes: [RoutesLink.attendance_summary],
        icon: <AttendanceIcon />,
      },
      {
        label: "Extra Work",
        to: RoutesLink.extra_work,
        relatedRoutes: [RoutesLink.extra_work],
        icon: <AttendanceIcon />,
      },
      {
        label: "Leave Request",
        to: RoutesLink.leave_request,
        relatedRoutes: [
          RoutesLink.leave_request,
          `${RoutesLink?.leave_detail}/:id`,
        ],
        icon: <LeaveIcon />,
      },
      {
        label: "Att. Regularization",
        to: RoutesLink.ar_request,
        relatedRoutes: [
          RoutesLink.ar_request,
          `${RoutesLink?.ar_request_detail}/:id`,
        ],
        icon: <AttRegulerizationIcon />,
      },
      {
        label: "OD Application",
        to: RoutesLink.od_request,
        relatedRoutes: [
          RoutesLink.od_request,
          RoutesLink.add_Od_request,
          `${RoutesLink.od_request_detail}/:id`,
        ],
        icon: <ODAplicationIcon />,
      },
      {
        label: "WFH Request",
        to: RoutesLink.wfh_request,
        relatedRoutes: [
          RoutesLink.wfh_request,
          RoutesLink.add_wfh_request,
          `${RoutesLink.wfh_request_detail}/:id`,
        ],
        icon: <LeaveIcon />,
      },
      {
        label: "Reimbursement",
        to: RoutesLink.my_Reimbursement_Form,
        relatedRoutes: [RoutesLink.my_Reimbursement_Form],
        icon: <PaySlipIcon />,
        subMenu: [
          {
            label: "Team Reimb.",
            to: RoutesLink.team_Reimbursement_Form,
            relatedRoutes: [
              RoutesLink.team_Reimbursement_Form,
              `${RoutesLink.team_Reimbursement_Form}/:id`,
            ],
          },
        ],
      },
      {
        label: "Payslip",
        to: RoutesLink.payslip,
        relatedRoutes: [RoutesLink.payslip],
        icon: <PaySlipIcon />,
      },
      {
        label: "HRM Settings",
        to: RoutesLink.shifts,
        relatedRoutes: [RoutesLink.shifts],
        icon: <AttendanceIcon />,
        subMenu: [
          {
            label: "Office Location",
            to: RoutesLink.office_location,
            relatedRoutes: [RoutesLink.office_location, RoutesLink.add_office],
          },
          {
            label: "Shift & Time Config",
            to: RoutesLink.shifts,
            relatedRoutes: [RoutesLink.shifts, RoutesLink?.add_Shift],
          },
          {
            label: "Employee Onboard",
            to: RoutesLink.employee_onboard,
            relatedRoutes: [
              RoutesLink.employee_onboard,
              RoutesLink?.add_employee_onboard,
              `${RoutesLink?.employee_detail}/:id`,
            ],
          },
          {
            label: "Salary Head",
            to: RoutesLink.salary_head,
            relatedRoutes: [RoutesLink.salary_head, RoutesLink.add_salary_head],
          },
          {
            label: "Leave Setting",
            to: RoutesLink.leave_setting,
            relatedRoutes: [
              RoutesLink.leave_setting,
              RoutesLink.add_leave_setting,
            ],
          },
          {
            label: "Holiday Setting",
            to: RoutesLink.holiday,
            relatedRoutes: [RoutesLink.holiday],
          },
          {
            label: "Site Salary Config",
            to: RoutesLink.site_salary_config,
            relatedRoutes: [RoutesLink.site_salary_config],
          },
          {
            label: "Office Salary Config",
            to: RoutesLink.office_salary_head,
            relatedRoutes: [RoutesLink.office_salary_head, RoutesLink.add_office_salary_head],
          },
          {
            label: "Transfer Requests",
            to: RoutesLink.transfer_requests,
            relatedRoutes: [RoutesLink.transfer_requests],
          },
        ],
      },
    ],
    Accounts: [
      {
        label: "Sales Order",
        to: RoutesLink.work_order,
        relatedRoutes: [
          RoutesLink.work_order,
          `${RoutesLink?.work_order_detail}/:id`,
        ],
        icon: <LedgerIcon />,
      },
      {
        label: "Invoice",
        to: RoutesLink.invoice,
        relatedRoutes: [
          RoutesLink.invoice,
          `${RoutesLink?.invoice_detail}/:id`,
        ],
        icon: <LedgerIcon />,
      },
      {
        label: "Debit Note",
        to: RoutesLink.debit_note,
        relatedRoutes: [RoutesLink.debit_note],
        icon: <LedgerIcon />,
      },
      {
        label: "Day Book",
        to: RoutesLink.day_book,
        relatedRoutes: [RoutesLink.day_book],
        icon: <LedgerIcon />,
      },
      {
        label: "Customer Ledger",
        to: RoutesLink.customer_ledger,
        relatedRoutes: [
          RoutesLink?.customer_ledger,
          `${RoutesLink?.customer_ledger_detail}/:id`,
        ],
        icon: <LedgerIcon />,
      },
      {
        label: "Vendor Ledger",
        to: RoutesLink.vendor_ledger,
        relatedRoutes: [
          RoutesLink.vendor_ledger,
          `${RoutesLink.vendor_ledger_detail}/:id`,
        ],
        icon: <LedgerIcon />,
      },
      {
        label: "TDS Ledger",
        to: RoutesLink.tds_ledger,
        relatedRoutes: [RoutesLink.tds_ledger, `${RoutesLink?.tds_detail}/:id`],
        icon: <LedgerIcon />,
      },

      {
        label: "Purchase Order",
        to: RoutesLink.purchase_order,
        relatedRoutes: [
          RoutesLink?.purchase_order,
          `${RoutesLink?.purchase_order_detail}/:id`,
        ],
        icon: <LedgerIcon />,
      },
      {
        label: "Payment Advisory",
        to: RoutesLink.payment_advisory,
        relatedRoutes: [RoutesLink.payment_advisory, `${RoutesLink.payment_advisory_detail}/:id`],
        icon: <VoucherIcon />,
      },
      {
        label: "Payment Overview",
        to: RoutesLink.payment_overview,
        relatedRoutes: [RoutesLink.payment_overview],
        icon: <VoucherIcon />,
      },
    ],
    SCM: [
      {
        label: "Purchase Request",
        to: RoutesLink.purchase_request,
        relatedRoutes: [
          RoutesLink.purchase_request,
          `${RoutesLink?.purchase_request_detail}/:id`,
          RoutesLink?.create_purchase_request,
        ],
        icon: <SitesIcon />,
      },
      {
        label: "Purchase",
        to: RoutesLink.purchase,
        relatedRoutes: [
          RoutesLink?.purchase,
          `${RoutesLink?.purchase_order_detail}/:id`,
          RoutesLink?.create_purchase,
        ],
        icon: <SitesIcon />,
      },
      {
        label: "Stock",
        to: RoutesLink.stock,
        relatedRoutes: [RoutesLink?.stock, `${RoutesLink?.stock_detail}/:id`],
        icon: <StockInOut />,
      },
      {
        label: "Stock Out",
        to: RoutesLink.stock_out,
        relatedRoutes: [
          RoutesLink?.stock_out,
          `${RoutesLink?.stock_out_detail}/:id`,
        ],
        icon: <StockInOut />,
      },
      {
        label: "Good Received Notes",
        to: RoutesLink.grn,
        relatedRoutes: [
          RoutesLink?.grn,
          RoutesLink?.createGrn,
          `${RoutesLink?.grn_detail}/:id`,
        ],
        icon: <SitesIcon />,
      },
      {
        label: "Transfer Assets",
        to: RoutesLink.transfer_assets,
        relatedRoutes: [RoutesLink?.transfer_assets],
        icon: <SitesIcon />,
      },
      {
        label: "Machinery",
        to: RoutesLink.machinery,
        relatedRoutes: [
          RoutesLink.machinery,
          RoutesLink.add_machinery,
          `${RoutesLink.machinery_details}/:id`,
        ],
        icon: <SitesIcon />,
        subMenu: [
          {
            label: "Machinery List",
            to: RoutesLink.machinery,
            relatedRoutes: [
              RoutesLink.machinery,
              `${RoutesLink.machinery_details}/:id`,
            ],
          },
          {
            label: "Add Machinery",
            to: RoutesLink.add_machinery,
            relatedRoutes: [RoutesLink.add_machinery],
          },
        ],
      },
      {
        label: "SCM Settings",
        to: RoutesLink.shifts,
        relatedRoutes: [RoutesLink.shifts],
        icon: <AttendanceIcon />,
        subMenu: [
          {
            label: "Vendor List",
            to: RoutesLink.vendor_list,
            relatedRoutes: [
              RoutesLink.vendor_list,
              RoutesLink?.add_vendor,
              `${RoutesLink?.vendor_detail}/:id`,
            ],
          },
          {
            label: "Expense Head",
            to: RoutesLink?.expense_head,
            relatedRoutes: [RoutesLink?.expense_head],
          },
          {
            label: "Gen.Expense Head",
            to: RoutesLink.general_expense_head,
            relatedRoutes: [RoutesLink.general_expense_head],
          },
          {
            label: "Service Type",
            to: RoutesLink.service_type,
            relatedRoutes: [RoutesLink.service_type],
          },
          {
            label: "Item Master",
            to: RoutesLink.item_master,
            relatedRoutes: [RoutesLink?.item_master],
          },
        ],
      },
    ],
    default: [
      {
        label: "Payment Tickets",
        to: RoutesLink.payment_ticket_against_po,
        relatedRoutes: [
          RoutesLink.payment_ticket_against_po,
          RoutesLink.payment_ticket_general,
        ],
        icon: "",
        isShowBorder: true,
        subMenu: [
          {
            label: "All Payment Tickets",
            to: RoutesLink?.payment_tickets_all,
            relatedRoutes: [
              RoutesLink?.payment_tickets_all,
              `${RoutesLink?.payment_tickets_details}/againstPO/:id`,
              `${RoutesLink?.payment_tickets_details}/general/:id`,
              `${RoutesLink?.payment_tickets_details}/reimbursement/:id`,
            ],
          },
          {
            label: "Against PO",
            to: RoutesLink?.payment_ticket_against_po,
            relatedRoutes: [
              RoutesLink?.payment_ticket_against_po,
              `${RoutesLink?.payment_tickets_details}/againstPo/:id`,
              RoutesLink?.create_against_po,
            ],
          },
          {
            label: "General",
            to: RoutesLink?.payment_ticket_general,
            relatedRoutes: [
              RoutesLink?.payment_ticket_general,
              `${RoutesLink?.payment_tickets_details}/general/:id`,
              RoutesLink?.create_general,
            ],
          },
          {
            label: "Reimbursement",
            permissionKey: "pt",
            to: RoutesLink?.payment_ticket_reimbursement,
            relatedRoutes: [
              RoutesLink?.payment_ticket_reimbursement,
              // `${RoutesLink?.payment_tickets_details}/general/:id`,
              RoutesLink?.create_reimbursement,
            ],
          },
        ],
      },
      {
        label: "Salary Tickets",
        to: RoutesLink.salary_ticket,
        relatedRoutes: [
          RoutesLink?.create_salary_ticket,
          RoutesLink?.salary_ticket_detail,
        ],
        icon: "",
      },
      {
        label: "Office Task Management",
        to: RoutesLink.task_management,
        relatedRoutes: [RoutesLink.task_management],
        icon: <OfficeTaskIcon />,
      },
      {
        label: "Site Task Management",
        to: RoutesLink.site_task_management,
        icon: <SiteTaskIcon />,
        isExternal: true,
      },
      {
        label: "How to Use",
        to: RoutesLink.how_to_use,
        relatedRoutes: [RoutesLink.how_to_use],
        icon: <HowToUseIcon />,
      },
    ],
  };

  const isRouteActive = (relatedRoutes = []) => {
    return relatedRoutes.some((route) => {
      if (!route) return false;
      if (route.includes("/:")) {
        const baseRoute = route.split("/:")[0];
        return location.pathname.startsWith(baseRoute);
      }
      return location.pathname === route;
    });
  };

  const toggleSidebarTab = (activeNumber) => {
    dispatch(saveSideBarScrollPosition(scrollPosition));
    if (activeSidebarTab === activeNumber) {
      dispatch(saveActiveSidebarTab(nonActiveNumber));
    } else {
      dispatch(saveActiveSidebarTab(activeNumber));
    }
  };

  useEffect(() => {
    const sidebarScroll = document.getElementById("sideWrapper");
    const handleScroll = () => {
      const scrollTop = sidebarScroll.scrollTop;
      dispatch(saveSideBarScrollPosition(scrollTop));
    };
    sidebarScroll?.addEventListener("scroll", handleScroll);

    return () => {
      sidebarScroll?.removeEventListener("scroll", handleScroll);
    };
  }, []);

  useEffect(() => {
    const sidebarScroll = document.getElementById("sideWrapper");
    if (sidebarScroll) {
      sidebarScroll.scrollTop = scrollPosition;
    }
  }, []);

  return (
    <>
      <aside className="sidebar-wrapper">
        <div className="sidebar-content">
          <NavLink to={RoutesLink?.dashboard} className="navbar-brand  ">
            <img
              className="main-logo"
              src={
                "/assets/img/Shreenath White Logo.png"
              }
              alt="main-logo"
            />
          </NavLink>
          <div className="sidebar-inner">
            <nav className="aside-nav" id="sideWrapper">
              <ul className="sidebar-vertical">
                <li>
                  <NavLink
                    to={RoutesLink?.dashboard}
                    className="drop-link"
                    onClick={() => {
                      dispatch(
                        updateFiltersStates({
                          paymentStatus: "",
                          currentPage: 1,
                          pageSize: 10,
                          count: 0,
                          totalPages: 0,
                          sortByDate: [
                            moment(
                              moment().subtract(30, "days").toDate()
                            ).format("YYYY-MM-DD"),
                            moment(moment().toDate()).format("YYYY-MM-DD"),
                          ],
                          year: getCurrentFinancialYear(),
                          companyId: "",
                          department: "",
                          designation: "",
                          requestType: "",
                          stockStatus: "",
                          vendorId: "",
                          empStatus: "current",
                          orderBy: "",
                          customerId: "",
                          customerCompanyId: "",
                        })
                      );
                      dispatch(
                        updateDateFilter([
                          moment().startOf("month").format("YYYY-MM-DD"),
                          moment().endOf("month").format("YYYY-MM-DD"),
                        ])
                      );
                      dispatch(saveActiveSidebarTab(nonActiveNumber));
                    }}
                  >
                    <DashboardIcon />
                    <span>Dashboard</span>
                  </NavLink>
                </li>
                <li>
                  <NavLink
                    to={RoutesLink?.operations_center}
                    className="drop-link"
                    onClick={() => {
                      dispatch(saveActiveSidebarTab(nonActiveNumber));
                    }}
                  >
                    <DashboardIcon />
                    <span>Operations Center</span>
                  </NavLink>
                </li>
                {Object.entries(groupedMenu).map(
                  ([sectionKey, items], sectionIndex) => (
                    <React.Fragment key={sectionKey}>
                      {items?.length > 0 && sectionKey !== "default" && (
                        <li key={`section-title-${sectionKey}`}>
                          <span className="menu-title border-top pt-3">
                            {sectionKey}
                          </span>
                        </li>
                      )}

                      {items.map((menuItem, itemIndex) => {
                        const index = sectionIndex * 10 + itemIndex;
                        const subMenus = menuItem.subMenu || [];
                        const hasSubMenu = subMenus.length > 0;
                        const isMenuActive = isRouteActive(
                          menuItem.relatedRoutes
                        );
                        const itemKey = `${sectionKey}-${menuItem.label}-${itemIndex}`;

                        if (hasSubMenu) {
                          return (
                            <React.Fragment key={itemKey}>
                              {menuItem?.isShowBorder && (
                                <li key={`border-${itemKey}`}>
                                  <span className="menu-title border-top"></span>
                                </li>
                              )}

                              <li key={`menu-${itemKey}`}>
                                <a
                                  className={`drop-link btn-menu ${activeSidebarTab === index ? "active" : ""
                                    }`}
                                  role="button"
                                  onClick={() => toggleSidebarTab(index)}
                                >
                                  {menuItem.icon}
                                  <span>{menuItem.label}</span>
                                  <ChevronArrow
                                    activeSidebarTab={activeSidebarTab}
                                    currentActiveTab={index}
                                  />
                                </a>

                                <ul
                                  className={`sub-menu1 ${activeSidebarTab === index
                                    ? "menu-open1"
                                    : "menu-close1"
                                    }`}
                                >
                                  {subMenus.map((sub, subIndex) => {
                                    const subKey = `${itemKey}-sub-${sub.label}-${subIndex}`;
                                    const isSubActive = isRouteActive(
                                      sub.relatedRoutes
                                    );
                                    return (
                                      <li key={subKey}>
                                        <NavLink
                                          to={sub.to}
                                          state={sub?.state}
                                          className={`drop-link inner ${isSubActive ? "active" : ""
                                            }`}
                                          role="button"
                                          onClick={() => {
                                            dispatch(
                                              updateFiltersStates({
                                                paymentStatus: "",
                                                currentPage: 1,
                                                pageSize: 10,
                                                count: 0,
                                                totalPages: 0,
                                                sortByDate: [
                                                  moment(
                                                    moment()
                                                      .subtract(30, "days")
                                                      .toDate()
                                                  ).format("YYYY-MM-DD"),
                                                  moment(
                                                    moment().toDate()
                                                  ).format("YYYY-MM-DD"),
                                                ],
                                                year: getCurrentFinancialYear(),
                                                companyId: "",
                                                department: "",
                                                designation: "",
                                                requestType: "",
                                                stockStatus: "",
                                                vendorId: "",
                                                empStatus: "current",
                                                orderBy: "",
                                                customerId: "",
                                                customerCompanyId: "",
                                              })
                                            );
                                            dispatch(
                                              updateDateFilter([
                                                moment()
                                                  .startOf("month")
                                                  .format("YYYY-MM-DD"),
                                                moment()
                                                  .endOf("month")
                                                  .format("YYYY-MM-DD"),
                                              ])
                                            );
                                          }}
                                        >
                                          <span>{sub.label}</span>
                                        </NavLink>
                                      </li>
                                    );
                                  })}
                                </ul>
                              </li>
                            </React.Fragment>
                          );
                        }

                        // No submenu
                        return (
                          <li key={`menu-${itemKey}`}>
                            {menuItem.isExternal ? (
                              <a
                                href={`${menuItem.to}${Cookies.get("token") || ""}`}
                                className={`drop-link ${isMenuActive ? "active" : ""}`}
                                target="_blank"
                                rel="noopener noreferrer"
                              >
                                {menuItem.icon}
                                <span>{menuItem.label}</span>
                              </a>
                            ) : (
                              <NavLink
                                to={menuItem.to}
                                className={`drop-link ${isMenuActive ? "active" : ""
                                  }`}
                                role="button"
                                onClick={() => {
                                  dispatch(
                                    updateFiltersStates({
                                      paymentStatus: "",
                                      currentPage: 1,
                                      pageSize: 10,
                                      count: 0,
                                      totalPages: 0,
                                      sortByDate: [
                                        moment(
                                          moment().subtract(30, "days").toDate()
                                        ).format("YYYY-MM-DD"),
                                        moment(moment().toDate()).format("YYYY-MM-DD"),
                                      ],
                                      year: getCurrentFinancialYear(),
                                      companyId: "",
                                      department: "",
                                      designation: "",
                                      requestType: "",
                                      stockStatus: "",
                                      vendorId: "",
                                      empStatus: "current",
                                      orderBy: "",
                                      customerId: "",
                                      customerCompanyId: "",
                                    })
                                  );
                                  dispatch(
                                    updateDateFilter([
                                      moment()
                                        .startOf("month")
                                        .format("YYYY-MM-DD"),
                                      moment()
                                        .endOf("month")
                                        .format("YYYY-MM-DD"),
                                    ])
                                  );
                                  dispatch(saveActiveSidebarTab(nonActiveNumber));
                                }}
                              >
                                {menuItem.icon}
                                <span>{menuItem.label}</span>
                              </NavLink>
                            )}
                          </li>
                        );
                      })}
                    </React.Fragment>
                  )
                )}

                <li>
                  <a
                    href={`http://oandm.shreenaths.com/?token=${Cookies.get("token") || ""}`}
                    className="drop-link"
                    target="_blank"
                    rel="noopener noreferrer"
                  >
                    <DashboardIcon />
                    <span>Generation</span>
                  </a>
                  {/* <a
                    href={` http://localhost:4173/?token=${Cookies.get("token") || ""}`}
                    className="drop-link"
                    target="_blank"
                    rel="noopener noreferrer"
                  >
                    <DashboardIcon />
                    <span>Generation</span>
                  </a> */}
                </li>
                <li>
                  <span className="menu-title  border-top"></span>
                </li>
                <li>
                  <NavLink
                    to={RoutesLink.notifications}
                    className="drop-link "
                    role="button"
                    onClick={() => {
                      dispatch(
                        updateFiltersStates({
                          paymentStatus: "",
                          currentPage: 1,
                          pageSize: 10,
                          count: 0,
                          totalPages: 0,
                          sortByDate: [
                            moment(
                              moment().subtract(30, "days").toDate()
                            ).format("YYYY-MM-DD"),
                            moment(moment().toDate()).format("YYYY-MM-DD"),
                          ],

                          year: getCurrentFinancialYear(),
                          companyId: "",
                          department: "",
                          designation: "",
                          requestType: "",
                          stockStatus: "",
                          vendorId: "",
                          empStatus: "current",
                          orderBy: "",
                          customerId: "",
                          customerCompanyId: "",
                        })
                      );
                      dispatch(
                        updateDateFilter([
                          moment().startOf("month").format("YYYY-MM-DD"),
                          moment().endOf("month").format("YYYY-MM-DD"),
                        ])
                      );
                      dispatch(saveActiveSidebarTab(nonActiveNumber));
                    }}
                  >
                    <NotificationIcon />
                    <span>Notifications</span>
                  </NavLink>
                </li>
              </ul>
            </nav>
          </div>
        </div>
      </aside>
    </>
  );
}

export default AdminSidebar;
